import { render, staticRenderFns } from "./AberrationProjectCard.vue?vue&type=template&id=08734496"
import script from "./AberrationProjectCard.vue?vue&type=script&lang=ts"
export * from "./AberrationProjectCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports